import { render } from "./SizeScaleEdit.vue?vue&type=template&id=7964a948"
import script from "./SizeScaleEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./SizeScaleEdit.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Admin/Database/SizeScaleEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7964a948"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7964a948', __exports__)) {
    api.reload('7964a948', __exports__)
  }
  
  module.hot.accept("./SizeScaleEdit.vue?vue&type=template&id=7964a948", () => {
    api.rerender('7964a948', render)
  })

}


export default __exports__